import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6e5afce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col clear-both" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "text-md" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/stones.png",
  alt: "Magnets stones",
  class: "w-3/4 mx-auto"
}, null, -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "2xl:px-10 flex-col items-center flex" }
const _hoisted_9 = {
  key: 0,
  src: "img/NdFeB-03.svg",
  alt: "Magnets structure",
  class: "w-full md:w-8/12"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReadMore = _resolveComponent("ReadMore")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Card, { class: "w-full" }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('magnetStructure.text1'),
                  class: "text-justify"
                }, null, 8, _hoisted_4),
                _hoisted_5,
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('magnetStructure.text2'),
                  class: "mt-4 text-justify"
                }, null, 8, _hoisted_6),
                _createVNode(_component_ReadMore, { class: "mt-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('magnetStructure.text3'),
                      class: "mt-4 text-justify"
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.$i18n.locale == 'en')
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: _ctx.localizedImage('img/couple.png'),
              alt: "Couple reading",
              class: "w-full md:w-8/12"
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}